import { useContext } from 'preact/hooks';
import { FormVariantContext } from './FormVariantContext';

/**
 * Utility hook for consuming the FormVariantContext
 *
 * @returns The value of the closest FormVariantContext provider
 */
export function useFormVariantContext() {
  return useContext(FormVariantContext);
}
